export default __webpack_public_path__ + "static/media/desktop-step4d.4b6546c7.png";